export default "__VITE_ASSET__UzmmWXfR__"